import { SearchSelectOptionProps } from "@alm/flow-ds/components";
import { IdData } from "hooks/FormDesigner/useElementList";
import api from "../api";

/**
 * Gets list of fields for a specific entity
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getEntityFields = async (entity: string): Promise<any[][]> => {
	const res = await api.request({
		url: `entities/resources/${entity}`,
		method: "GET",
	});

	return Object.entries(res.data.data.properties).sort((a, b) => {
		return a[0].toLowerCase().localeCompare(b[0].toLowerCase());
	});
};

/**
 *  Gets list of fields for a specific entity with field path passed and formats for search select (SearchSelectOptionProps path)
 */
const getEntityProperties = async (
	entity: string,
	isEmu?: boolean
): Promise<SearchSelectOptionProps[]> => {
	const entityFields = await getEntityFields(entity);
	const data: SearchSelectOptionProps[] = [];

	entityFields.forEach((item, index) => {
		if (!isEmu && entityFields[index][1].hasOwnProperty("enum")) {
			data.push({
				value: `/properties/${item[0]}/enum`,
				label: item[0],
			});
		} else if (isEmu && entityFields[index][1].hasOwnProperty("array")) {
			data.push({
				value: `/properties/${item[0]}`,
				label: item[0],
			});
		}
	});

	return data;
};

/**
 *  Gets list of values for a select
 */
const getSelectData = async (
	entity: string,
	field: string,
	isEmu?: boolean
): Promise<SearchSelectOptionProps[]> => {
	let values: string[] = [];

	if (isEmu) {
		values = [];
	} else {
		const res = await api.request({
			url: `entities/resources/${entity}`,
			method: "GET",
		});
		values =
			res.data !== undefined &&
			res.data.data !== undefined &&
			res.data.data.properties !== undefined &&
			res.data.data.properties[field] !== undefined &&
			res.data.data.properties[field].enum !== undefined
				? res.data.data.properties[field].enum
				: [];
	}
	const data: SearchSelectOptionProps[] = [];

	values.forEach(value => {
		data.push({ value: value, label: value });
	});

	return data;
};

/**
 * Gets list of fields for a specific entity and formats for search select (e.g. collect)
 */
const getEntityData = async (entity: string): Promise<IdData> => {
	if (entity === "NoEntity") {
		return [];
	} else {
		const entityFields = await getEntityFields(entity);
		const data: IdData = [];

		entityFields.forEach(item => {
			data.push({
				value: `/${item[0]}`,
				label: `${item[0]}`,
				// label: `${item[0]} - ${item[1]?.description}`,
			});
		});

		return data;
	}
};

/**
 * Gets the list of all entities from the shim
 *
 */
const getEntities = async (): Promise<SearchSelectOptionProps[]> => {
	const res = await api.request({
		url: "entities/resources",
		method: "GET",
	});

	const entityOptions: SearchSelectOptionProps[] = res.data.matches
		.filter(({ id, data }: { id: string; data: { title: string } }) => {
			if (!id.includes("/shared/")) {
				return { id, data };
			}
			return null;
		})
		.map(({ id, data }: { id: string; data: { title: string } }) => {
			const idWithResources = id.includes("/resources/")
				? id
				: [
						id.slice(0, id.lastIndexOf("/")),
						"/resources",
						id.slice(id.lastIndexOf("/")),
				  ].join("");
			const option = {
				value: idWithResources,
				label: data.title,
			};
			return option;
		});

	return entityOptions;
};

export default {
	getEntities,
	getEntityData,
	getEntityProperties,
	getSelectData,
};
